var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedMin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 4.5C5.15883 4.5 6 3.65883 6 2.625C6 1.59117 5.15883 0.75 4.125 0.75C3.09117 0.75 2.25 1.59117 2.25 2.625C2.25 3.65883 3.09117 4.5 4.125 4.5ZM12.375 1.5H7.125C6.91781 1.5 6.75 1.66781 6.75 1.875V5.25H1.5V0.375C1.5 0.167812 1.33219 0 1.125 0H0.375C0.167812 0 0 0.167812 0 0.375V8.625C0 8.83219 0.167812 9 0.375 9H1.125C1.33219 9 1.5 8.83219 1.5 8.625V7.5H13.5V8.625C13.5 8.83219 13.6678 9 13.875 9H14.625C14.8322 9 15 8.83219 15 8.625V4.125C15 2.67516 13.8248 1.5 12.375 1.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedMin);
export default __webpack_public_path__ + "static/media/bed_min.e3d2aba456986516e200d73e913baa05.svg";
export { ForwardRef as ReactComponent };